import React, { useState, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// import Input from "./input";
import FontAwesome from "react-fontawesome";
// import Renderlist from "./renderdetail";
// import { savtruckover } from "../../services/wms";
import { toast } from "react-toastify";
import Input from "../common/inputcustom";
import Select from "../common/selectcustom";
import { getcarcolor, getcartype, saveregister } from "../../services/car";
import { assign } from "lodash";
const Modalregister = ({
  isOpen,
  header,
  onCancel,
  onConfirm,
  message,
  list,
  onDisAprove,
  value,
  onChange,
  onProgress,

  size = "lg",
}) => {
  const [text, settext] = useState("");
  const [carcolor, setcarcolor] = useState([]);
  const [cartype, setcartype] = useState([]);
  const [carcolorid, setcarcolorid] = useState(0);
  const [cartypeid, setcartypeid] = useState(0);
  const [tel, settel] = useState("");
  const [error, seterror] = useState("");
  const [driven, setdriven] = useState("");
  const [messageErros, setmessageErros] = useState({
    askAlert: { enable: false, message: "" },
  });

  const dosubmit = async (doc) => {
    const { data: result } = await saveregister(doc);
    if (result.status === "success") {
      toast.success("บันทึกข้อมูลเรียบร้อย");
      onConfirm() 
    }
    else { toast.error(result.message);}
  }

  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getcarcolor();


      if (result.status === "success") {

        setcarcolor(result.data.list)
      }
    };
    loadData();
  }, [list]);
  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getcartype();
      if (result.status === "success") {
        setcartype(result.data.list)

      }
    };
    loadData();
  }, [list]);
  const hadleclickcarcolor = (e) => {
    setcarcolorid(e.currentTarget.value)
  }
  const hadleclickcartype = (e) => {
    setcartypeid(e.currentTarget.value)
    if (e.currentTarget.value !== '') { seterror('') }
  }
  const hadleonchangtel = (e) => {
    settel(e.currentTarget.value)
    if (e.currentTarget.value !== '') { seterror('') }
  }
  const SavedoSubmit = (e) => {
    if (!driven) {
      seterror("ระบุทะเบียนรถ")
      return
    }
    else if (!cartypeid) {
      seterror("เลือกประเภทรถ")
      return
    }
    else if (!carcolorid) {
      seterror("เลือกสี")
      return
    }
    else if (!tel) {
      seterror("ระบุเบอร์โทร")
      return
    }
    const doc = { cartypeid, carlicense: driven, colorid: carcolorid, phone: tel }
    dosubmit(doc)
    // console.log("xx", doc)
  }
  const hadleonchangdriven = (e) => {
    setdriven(e.currentTarget.value)
    if (e.currentTarget.value !== '') { seterror('') }
  }


  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>
          <div className="card text-center border border-top-5 border-right-5 border-left-5"
            style={{ fontSize: 14 }}>
            <span className="bg-info text-light" style={{ fontSize: 20 }}>ลงทะเบียนจองที่จอดรถ</span></div>




        </ModalHeader>
        <ModalBody>
          <div className="row md-5">
            <div className="col-6 md-4">
              <span >ชื่อ : </span>
               <span className="badge bg-secondary text-wrap text-light" style={{ fontSize: 16 }}>{list[0]} </span>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row m-1">
              <div className="col-4">
                <div className="form-group">
                  <Input
                    name="name"
                    value={driven}
                    label="ทะเบียนรถ"
                    placeholder="ดด 1759 กทม"
                    onChange={hadleonchangdriven}

                  />

                </div>

              </div>
              <div className="col-4">
                <div className="form-group">
                  <Select
                    label="ประเภทรถ"
                    data={cartype}
                    value={cartypeid}
                    onChange={hadleclickcartype}

                  />

                </div>

              </div>
              <div className="col-4">
                <div className="form-group">
                  <Select
                    label="สีรถ"
                    data={carcolor}
                    value={carcolorid}
                    onChange={hadleclickcarcolor}

                  />

                </div>

              </div>
            </div>
            <div className="row m-1">
              <div className="col-6">
                <div className="form-group">
                  <Input
                    name="name"
                    value={tel}
                    label="เบอร์โทรศัพท์"
                    placeholder="085835XXXX"
                    onChange={hadleonchangtel}

                  />
                </div>
              </div>
            </div>
          </div>


          {error && <div className="col-md-12 alert alert-danger"> {error}</div>}

        </ModalBody>



        <ModalFooter>
          {/* <Button color="primary" onClick={SavedoSubmit}>
            Save
          </Button> */}

          <div className="row  col-auto">
            <button className="btn-success" onClick={SavedoSubmit} >บันทึก</button>
          </div>
          <div className="row  col-auto">
            <button className="btn-danger " onClick={onCancel} >ยกเลิก</button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Modalregister;
